import { render, staticRenderFns } from "./PrvErrorMessage.vue?vue&type=template&id=b41294d6&scoped=true&"
import script from "./PrvErrorMessage.vue?vue&type=script&lang=js&"
export * from "./PrvErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./PrvErrorMessage.vue?vue&type=style&index=0&id=b41294d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41294d6",
  null
  
)

export default component.exports